import { fetchWrapper } from "@/helpers";

const ruta = process.env.VUE_APP_ROOT_API;

export default class PromotionService {
    getPromotions() {
        return fetchWrapper.get(`${ruta}/promociones`);
    }

    getPromotion(id) {
        return fetchWrapper.get(`${ruta}/promociones/${id}`);
    }

    savePromotion(promotion) {
        if (promotion.id) {
            return fetchWrapper.put(`${ruta}/promociones/${promotion.id}`, promotion);
        } else {
            return fetchWrapper.post(`${ruta}/promociones`, promotion);
        }
    }

    deletePromotion(id) {
        return fetchWrapper.delete(`${ruta}/promociones/${id}`);
    }
}
